import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { BrowserTracing } from '@sentry/tracing';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
// import * as Sentry from "@sentry/angular";

// Sentry.init({
//   dsn: "https://325055b591d244faa8f89d5aeedcc87b@o1138343.ingest.sentry.io/6223044",
//   integrations: [
//     new BrowserTracing({
//       tracingOrigins: ["localhost", environment.apiUrl],
//       routingInstrumentation: Sentry.routingInstrumentation,
//     }),
//   ],

//   // Set tracesSampleRate to 1.0 to capture 100%
//   // of transactions for performance monitoring.
//   // We recommend adjusting this value in production
//   tracesSampleRate: 1.0,
//   environment: environment.environment,
// });

if (environment.production) {
  enableProdMode();
}

document.addEventListener('DOMContentLoaded', () => {
  platformBrowserDynamic().bootstrapModule(AppModule)
    .catch((err) => {
      throw new Error(err);
    });
});
